import { decode as fromBase64 } from "safe-base64";

function confirmed() {
  const params = new URLSearchParams(location.search);
  const tokenBase64 = params.get("token");

  const $token = document.getElementById("token");
  const $tokenInfo = document.getElementById("tokenInfo");
  const $btnCopyToClipboard = document.getElementById("copyToClipboard");

  if (!$token || !$tokenInfo || !$btnCopyToClipboard) {
    console.error("some nodes couldn't be found");
    return;
  }

  if (tokenBase64) {
    const token = fromBase64(tokenBase64).toString();
    $token.innerText = token;
    $tokenInfo.hidden = false;
    $btnCopyToClipboard.addEventListener("click", () => {
      navigator.clipboard.writeText(token);
      alert("ThankU Postpaid Token copied to clipboard");
    });
  }
}

document.addEventListener("DOMContentLoaded", confirmed);
